import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function E() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('refurbished');
    const { locale } = useRouter();
    const lists: any = [
        {
            title: t('secE_q1'),
            desc: t('secE_a1'),
        },
        {
            title: t('secE_q2'),
            desc: t('secE_a2'),
        },
        {
            title: t('secE_q3'),
            desc: t('secE_a3'),
        },
        {
            title: t('secE_q4'),
            desc: t('secE_a4'),
        },
        {
            title: t('secE_q5'),
            desc: t('secE_a5'),
        },
        {
            title: t('secE_q6'),
            desc: t.rich('secE_a6', {
                a1: (text: string) => (
                    <Link href={`https://${locale}.ecoflow.com/pages/ecoflow-return-policy`} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
    ];
    return (
        <div id="refurbished-E" className={`refurbished-E ${css['refurbished-E']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secE_title')}</p>
                </div>
                <Collapse
                    ghost={true}
                    className="collapse-lists"
                    defaultActiveKey={0}
                    // onChange={setActive}
                    // accordion={true}
                    expandIcon={({ isActive }: any) => {
                        return (
                            <svg
                                className={`collapse-icon ${isActive ? 'active' : ''}`}
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                            >
                                <path d="M17.5 15L12.5 10L7.5 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        );
                    }}
                    expandIconPosition="right"
                >
                    {lists?.map((list: any, k: number) => (
                        <Collapse.Panel className="list-title" key={k} header={list.title}>
                            <p className="list-desc">{list.desc}</p>
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </div>
        </div>
    );
}
